<div class="section-list card card-main-section">

  <nav class="navbar navbar-expand-sm navbar-light bg-light justify-content-between section-header nav-2rows">
    <div class="section-header">
      <div class="section-icon bg-danger"><i class="fas fa-user"></i> User</div>
      <div class="section-detail">
        <div class="section-detail-th">User</div>
        <div class="section-detail-td section-detail-tit ">
          {{model?.name}} {{model?.surname}}
        </div>
      </div>
      <div class="section-detail">
        <div class="section-detail-th">Last Modify</div>
        <div class="section-detail-td sm-1 text-center">{{model?.info?.updating_date | date:'dd-MM-yyyy HH:mm'}}</div>
      </div>
    </div>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <div class="ml-auto d-flex justify-content-end">
        <ul class="nav navbar-nav ml-auto">
          <li>
            <button matTooltip="Save site basic data" type="button" class="btn btn-sm  btn-success "
              [disabled]="!isvalid||submitted" (click)="saveModel()">
              <i class="far fa-save"></i> Save
            </button>
          </li>
          <li class="nav-item dropdown" dropdown placement="bottom right">
            <a class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
              aria-expanded="false" dropdownToggle (click)="false">
              <i class="fas fa-ellipsis-v"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown1">
              <!--               <a class="nav-link" role="button" (click)="changepwd_openmodal();false">
                <i class="fas fa-key"></i> Change password
              </a> -->
              <a class="nav-link" role="button" (click)="getViewModel();false">
                <i class="fas fa-sync"></i> Reload data
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>


  <div class="card-body">
    <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
    <app-frms-messagebar #frmsmessagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4">
          <app-user-edit #editform [uitype]="2" [ismodal]="true" [showheader]="true" [model]="model"></app-user-edit>
        </div>
        <div class="col-md-8">
          <!-- <app-role-list [user]="model"></app-role-list> -->
          <app-user-sites-list #sitesAsigned [userSite]="model"></app-user-sites-list>
        </div>
      </div>      
    </div>

  </div>
</div>